<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <bita-form ref="filterForm">
            <div slot="body">
              <div class="row">
                <bita-input
                  type="text"
                  name="name"
                  label="جستجو"
                  validation-container-class="col-lg-3"
                  input-class="form-control"
                  v-model.lazy="filters.search"
                  @keyup.enter="loadData()"
                />
                <div class="col-lg-4">
                  <a class="margin-top btn btn-success" @click="loadData()">
                    جستجو
                  </a>
                  <a
                    class="margin-top margin-right btn btn-warning"
                    @click="resetFilters()"
                  >
                    پاک سازی
                  </a>
                </div>
              </div>
            </div>
          </bita-form>
          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
            :batch="true"
            :page-size="pageSize"
            :current-page="currentPage"
            :has-row-number="true"
          />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>
<script>
import { userApi } from "@/api/apiManagement.js";
export default {
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "رویداد های انتخابی کاربران",
          link: "/management/events/registered",
          active: true,
        },
      ],
      filters: {},
      isLoadingGrid: false,
      gridColumns: [
        {
          field: "user",
          title: "کاربر",
          template: (e) => (e.user ? e.user.full_name : "-"),
        },
        {
          field: "product",
          title: "محصول",
          template: (e) => (e.product ? e.product.name : "-"),
        },
        {
          field: "email",
          title: "ایمیل",
          template: (e) => (e.user ? e.user.email : "-"),
        },
        {
          field: "mobile",
          title: "شماره تماس",
          template: (e) => (e.user ? e.user.mobile : "-"),
        },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
        },
      ],
    };
  },
  // mounted() {
  //   this.loadData();
  // },
  methods: {
    readData(e) {
      this.$resetGrid();
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.isLoadingGrid = true;
      userApi
        .getRegisteredEvents({
          page_size: this.pageSize,
          page: this.currentPage,
          ...this.filters,
        })
        .then((res) => {
          e.success(res.data.entity.events);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },

    loadData() {
      this.$refs.grid.loadDataSource();
    },

    resetFilters() {
      this.filters = {};
    },
  },
};
</script>
